import { useMotionRail } from "./MotionRailProvider";

/**
 * Right-edge progress rail. 1px terracotta line, scaleY tied to scroll
 * progress. Hidden < 768px. Mounted once at app root.
 */
export function ScrollRail() {
  const { progress } = useMotionRail();
  return (
    <div
      className="scroll-rail hidden md:block"
      aria-hidden="true"
      style={{ ["--p" as string]: progress.toFixed(4) }}
    >
      <span className="scroll-rail__track" />
      <span className="scroll-rail__fill" />
    </div>
  );
}

export default ScrollRail;
